import { Injectable, inject } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as i18ncountries from 'i18n-iso-countries';
import * as i18ncountriesLocaleNl from 'i18n-iso-countries/langs/nl.json';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    private translateService = inject(TranslateService);

    private translations;
    private i18ncountries;
    private onTranslationChangedSubject = new BehaviorSubject<string>(undefined);

    constructor() {
        this.i18ncountries = i18ncountries;
        this.i18ncountries.registerLocale(i18ncountriesLocaleNl);
    }

    public add(translations: Record<string, object>): void {
        this.translations = translations;
        this.translateService.addLangs(Object.keys(this.translations));
    }

    public set(language: string): void {
        this.translateService.setFallbackLang(language);
        this.translateService.setTranslation(language, this.translations[language]);
        this.onTranslationChangedSubject.next(language);
    }

    public onTranslationChanged(): Observable<string> {
        return this.onTranslationChangedSubject.asObservable();
    }

    public addCountries(): void {
        const keyValueList = this.i18ncountries.getNames(this.translateService.getFallbackLang(), {select: "alias"} );
        const keyValueListWithCountryNames = {};
        Object.keys(keyValueList).forEach((countryCode: string) => {
            keyValueListWithCountryNames['country.' + countryCode] = keyValueList[countryCode];
        });
        this.add(keyValueListWithCountryNames);
    }

    public getCountryName( countryCode: string ): string {
        return this.i18ncountries.getName( countryCode, this.translateService.getFallbackLang(), {select: "alias"} );
    }

    public getCountriesAsKeyValue(): {id: string; name: string}[]  {
        const keyValueList = this.i18ncountries.getNames( this.translateService.getFallbackLang(), {select: "alias"} );
        const keyValueListWithCountryNames = [];
        Object.keys(keyValueList).forEach((countryCode: string) => {
            keyValueListWithCountryNames.push({id: countryCode, name: keyValueList[countryCode]});
        });
        return keyValueListWithCountryNames;
    }
}
